import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from './../../../../auth/apigee/apigee.service';
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { DateRange } from "./dateRange";
import { OrdersKpiCfg, OrdersKpiCfgService } from "./ordersKpiCfg.service";
import { OrdersKpiService, Range } from "./ordersKpiService";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class PendingOrdersServiceData {
    public consultantBucketPermanent: number;
    public consultantBucketTEA: number;
    public officeBucketPermanent: number;
    public officeBucketTEA: number;
    public consultantNoBucketPermanent: number;
    public consultantNoBucketTEA: number;
    public officeNoBucketPermanent: number;
    public officeNoBucketTEA: number;
    public updateTimestamp: Date;
}

export abstract class PendingOrdersService extends OrdersKpiService<PendingOrdersServiceData> {
    protected abstract getRange(): DateRange;

    constructor(private serviceCfg: OrdersKpiCfgService, private apigeeService: ApigeeService, private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(this.getRange());
    }

    protected async update(): Promise<PendingOrdersServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: PendingOrdersServiceData = null;
            try {
                let cfg: OrdersKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDateRange(this.getRange());
                let url = cfg.pendingOrders.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.post<PendingOrdersServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastPendingOrdersService extends PendingOrdersService {
    constructor(serviceCfg: OrdersKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    public getClassName() { return "PastPendingOrdersService"; }

    protected getRange(): DateRange { return DateRange.Past; };
}

@Injectable()
export class InmediatePendingOrdersService extends PendingOrdersService {
    constructor(serviceCfg: OrdersKpiCfgService, apigeeService: ApigeeService, impersonationService: ImpersonationService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, impersonationService, officeSelectorService, httpClient, injector);
    }

    public getClassName() { return "InmediatePendingOrdersService"; }

    protected getRange(): DateRange { return DateRange.Inmediate; };
}
